import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import useStyle from "./CardContainer.style";
export default function CardContainer(param) {
    var _orientation = param.orientation, orientation = _orientation === void 0 ? 'horizontal' : _orientation, _responsive = param.responsive, responsive = _responsive === void 0 ? false : _responsive, _width = param.width, width = _width === void 0 ? 500 : _width, height = param.height, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, _hasBorder = param.hasBorder, hasBorder = _hasBorder === void 0 ? false : _hasBorder, _elevation = param.elevation, elevation = _elevation === void 0 ? 2 : _elevation, children = param.children;
    var outerContainerStyle = useStyle({
        orientation: orientation,
        responsive: responsive,
        width: width,
        height: height,
        isRtl: isRtl,
        hasBorder: hasBorder,
        elevation: elevation
    }).outerContainerStyle;
    return _jsx("div", {
        css: outerContainerStyle,
        children: children
    });
};
